<template>
    <div class="testimonial-item">
        <p class="testimonial__quote">TripIt is a good platform to look for great destinations. It keeps me organized while giving me the best options available.</p>

        <router-link v-bind:to="{ name: 'Profile' }" class="testimonial__owner">
            <img src="assets/images/avatar1.png" class="avatar" alt="Jennifer Brit's avatar" />
            <div class="testimonial__owner__details">
                <div class="testimonial__owner__name">Jennifer Brit</div>
                <div class="testimonial__owner__desc">TripIt member, wanderlust traveller</div>
            </div>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'TestimonialItem'
    }
</script>

<style scoped lang="scss">
    .testimonial-item {
        background-color: #FFF;
        margin: 0 auto;
        width: 100%;
        max-width: 740px;
        box-shadow: 1px 2px 4px rgba(200, 200, 200, 0.5);

        @media all and (min-width: $breakpoint + 1) {
            padding: 66.6px 0 46px;
            height: 336px;
        }

        @media all and (max-width: $breakpoint) {
            padding: 20px 0;
            height: auto;
        }
    }

    .testimonial-item:not(:first-child) {
        margin-top: 36px;

        @media all and (max-width: $breakpoint) {
            margin-top: 15px;
        }
    }


    .testimonial__quote {
        margin: 0 auto;
        text-align: center;
        font-style: italic;
        font-weight: $book;
        color: $accent-two;

        @media all and (min-width: $breakpoint + 1) {
            max-width: 522px;
            line-height: 38px;
            font-size: 24px;
        }

        @media all and (max-width: $breakpoint) {
            max-width: none;
            line-height: 24px;
            font-size: 16px;
        }
    }

    .testimonial__quote::before,
    .testimonial__quote::after {
        content: "\"";
        display: inline;
    }


    .testimonial__owner {
        display: flex;
        align-items: center;
        margin: 61.4px auto 0;
        width: max-content;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    .testimonial__owner .avatar {

        @media all and (min-width: $breakpoint + 1) {
            width: 48px;
            height: 48px;
        }

        @media all and (max-width: $breakpoint) {
            width: 36px;
            height: 36px;
        }
    }


    .testimonial__owner__details {
        margin-left: 16px;
        color: #545454;
    }


    .testimonial__owner__name {
        font-weight: $heavy;
    }


    .testimonial__owner__desc {
        font-size: 12px;
    }
</style>
